import { render, staticRenderFns } from "./DirectDeleteAccount.vue?vue&type=template&id=582d8adc&scoped=true&"
import script from "./DirectDeleteAccount.vue?vue&type=script&lang=js&"
export * from "./DirectDeleteAccount.vue?vue&type=script&lang=js&"
import style0 from "./DirectDeleteAccount.vue?vue&type=style&index=0&id=582d8adc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582d8adc",
  null
  
)

export default component.exports